module.exports = __webpack_public_path__ + "static/media/img_01.3ba643b1.png";